import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute }       from '@angular/router';
import { CreatePaymentModel } from '@omnilnp/models/create-payment.model';
import { TempLibModel } from '@omnilnp/models/temp-lib.model';
import { DataService }          from '@omnilnp/services/data.service';
import { IconsService }         from '@omnilnp/services/icons.service';
import { LanguageService }      from '@omnilnp/services/language.service';
import { PaymentService } from '@omnilnp/services/payment.service';
import { RegisterService }      from '@omnilnp/services/register.service';
import { RenewalService }       from '@omnilnp/services/renewal.service';
import { RouterService }        from '@omnilnp/services/router.service';
import { TempLibService } from '@omnilnp/services/temp-lib.service';
import { format, parseISO, toDate  }  from 'date-fns';

@Component({
  selector: 'lenerspas-payment',
  templateUrl: './payment.component.html'
})
export class PaymentComponent implements OnInit {

  initialized: boolean = false;
  loaded:      boolean = false;

  result: string = '';

  createPaymentModel: CreatePaymentModel;
  tempLibModel: TempLibModel;

  pspType: string = 'ingenico';
  worldlineRedirectUrl: string = '';

  constructor ( public  route:          ActivatedRoute
              , public  data:           DataService
              , public  icons:          IconsService
              , public  language:       LanguageService
              , public  register:       RegisterService
              , public  renewal:        RenewalService
              , public  router:         RouterService
              , public paymentService: PaymentService
              , private tempLibService: TempLibService
              ) {
    this.createPaymentModel = new CreatePaymentModel();
    this.tempLibModel = new TempLibModel();
  }

  async ngOnInit() {
    this.router.showwait = true;
    this.initialized = false;

    await this.HandleWorldlineDirectPayment();
  }

  async HandleWorldlineDirectPayment() {
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['hostedCheckoutId']) {
      this.handlePaymentReturn(queryParams['hostedCheckoutId']);
    } else {
      await this.initializeWorldlineDirect();
    }
  }

  async initializeWorldlineDirect() {
    try {
      this.createPaymentModel.email = this.register.formitems.emailaddress.value;
      this.createPaymentModel.borrowTypeCode = this.register.formitems.membertype.value;
      this.createPaymentModel.language = this.language.currentLanguage;

      this.paymentService.getHostedCheckout(this.createPaymentModel).subscribe({
        next: res => {
          this.worldlineRedirectUrl = res.redirectUrl;
          this.result = 'start';  
          this.saveTemp(res.orderId);
        },
        error: e => {
          this.router.success = false;
          this.router.message = 'failed_payment_text';
        }
      })
    } catch (error) {
      this.router.success = false;
      this.router.message = 'failed_payment_text';
    }
  }

  proceedToWorldlinePayment() {
    window.location.href = this.worldlineRedirectUrl;
  }

  async handlePaymentReturn(hostedCheckoutId: string) {
    try {
      this.router.title = 'register'
      this.paymentService.getPaymentStatus(hostedCheckoutId).subscribe({
        next: res => {
          switch (res.status) {
              case 'COMPLETED':
              case 'PAYMENT_CREATED':
              case 'SUCCESSFUL':
                this.router.message = 'success_register_text'
                this.router.success = true;
                this.router.navigateto('result');
                break;
              case 'REJECTED':
              case 'CANCELLED':
              case 'ERROR':
                this.router.success = false;
                this.router.message = 'failed_payment_text';
                this.router.navigateto('result');
                break;
              default:
                this.router.success = false;
                this.router.message = 'failed_payment_text';
                this.router.navigateto('result');
                break;
            }
        },
        error: e => {
          this.router.success = false;
          this.router.message = 'failed_payment_text';
          this.router.navigateto('result');
        }
      })
    } catch (error) {
      this.router.success = false;
      this.router.message = 'failed_payment_text';
      this.router.navigateto('result');
    }
  }



  saveTemp(orderId: string) {
    this.tempLibModel.orderId = orderId;
    this.tempLibModel.initials = this.register.formitems.initials.value;
    this.tempLibModel.lastName = this.register.formitems.lastname.value;
    this.tempLibModel.dateOfBirth = format(parseISO(this.register.formitems.dateofbirth.value+'T00:00:00'),'dd-MM-yyyy');
    this.tempLibModel.country = this.register.formitems.country.value;
    this.tempLibModel.postalCode = this.register.formitems.zipcode.value.trim();
    this.tempLibModel.streetName = this.register.formitems.street.value.trim();
    this.tempLibModel.houseNumber = this.register.formitems.housenumber.value.trim();
    this.tempLibModel.houseNumberSuffix = this.register.formitems.housenumber_suffix.value.trim();
    this.tempLibModel.city = this.register.formitems.city.value.trim();
    this.tempLibModel.phoneNumber = this.register.formitems.phonenumber.value;
    this.tempLibModel.email = this.register.formitems.emailaddress.value;
    this.tempLibModel.borrowerType = this.register.formitems.membertype.value;
    this.tempLibModel.streetNameDutch = this.register.dutchaddress.street.value.trim();
    this.tempLibModel.houseNumberDutch = this.register.dutchaddress.housenumber.value.trim();
    this.tempLibModel.houseNumberSuffixDutch = this.register.dutchaddress.housenumber_suffix.value.trim();
    this.tempLibModel.postalCodeDutch = this.register.dutchaddress.zipcode.value.trim();
    this.tempLibModel.cityDutch = this.register.dutchaddress.city.value.trim();
    this.tempLibModel.language = this.language.currentLanguage == 'nl' ? 'NED' : 'ENG';

    
    this.tempLibService.saveTempLib(this.tempLibModel).subscribe({
      next: res => {
        this.proceedToWorldlinePayment();
      },
      error: e => {
        console.error(e);
        this.router.success = false;
        this.router.message = 'failed_payment_text';
      }
    })
  }
}
